declare const I18n;

import React from "react";
import RadioInput from "./inputs/RadioInput";
import { getByPath } from "@/utils/getByPath";
import { evaluateConditions } from "@/utils/evaluateConditions";

type Props = {
  block: any;
  data: Record<string, any>;
  onChange: (
    key: string,
    value: any,
    options?: { remove?: boolean; groupKey?: string }
  ) => void;
};

const RadioGroup: React.FC<Props> = ({ block, data, onChange }) => {
  const sectionGroup = block.inputGroup;

  const getFieldPath = (key?: string) => {
    return sectionGroup && key ? `${sectionGroup}.${key}` : key || "";
  };

  const readValue = (key: string) => getByPath(data, getFieldPath(key));

  const writeValue = (key: string, val: any, opts: { remove?: boolean } = {}) => {
    onChange(key, val, { ...opts, groupKey: sectionGroup });
  };

  return (
    <>
      {block.props.fields.map((field: any) => {
        if (field.showIf && !evaluateConditions(field.showIf, data)) return null;
        if (!field.options) return null;

        const currentValue = readValue(field.key);

        const fieldLabel = field.labelKey
          ? I18n.t(field.labelKey)
          : field.label || "";

        const isSingle = field.options.length === 1;

        return (
          <div key={field.key} className="choice-group">
            {fieldLabel && (
              <div className="choice-group__label">{fieldLabel}</div>
            )}

            <div className={`choice-grid ${isSingle ? 'choice-grid--single' : 'choice-grid--multi'}`}>
              {field.options.map((opt: any) => {
                const optionLabel = opt.labelKey
                  ? I18n.t(opt.labelKey)
                  : opt.label || "";
                return (
                  <div key={opt.value} className="choice-grid__item">
                    <RadioInput
                      label={optionLabel}
                      name={field.key}
                      value={opt.value}
                      checked={String(currentValue) === opt.value}
                      onChange={() => {
                        const newVal = currentValue === opt.value ? "" : opt.value;
                        writeValue(field.key, newVal || "", { remove: !newVal });
                      }}
                    />
                  </div>
                );
              })}
            </div>
          </div>
        );
      })}
    </>
  );
};

export default RadioGroup;